type RawPayableCounts = {
  company: {
    toPreparePayables: {
      totalCount: number;
    };
  };
};

export const reshapePayableCounts = (rawPayableCounts: RawPayableCounts) => {
  return {
    toPrepareCount: rawPayableCounts.company.toPreparePayables.totalCount,
  };
};
